import { Component, Inject, OnInit } from '@angular/core';
import { SupportedTypes, Ticket } from './../../../../projects/kiene-core/src/lib/classes/ticket';
import { Subscription } from 'rxjs';
import { API_BASE_URL_SERVICE } from './../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from './../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { MessageService } from './../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { FormControl, Validators } from '@angular/forms';
import { AppService } from './../../../../projects/kiene-core/src/lib/services/app/app.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-ticket-type-dialog',
    templateUrl: './ticket-type-dialog.component.html',
    styleUrls: ['./ticket-type-dialog.component.scss'],
})
export class TicketTypeDialogComponent implements OnInit {
    supportTypes: SupportedTypes[] = [];
    ticketTyp: SupportedTypes;
    supportTypeSub = new Subscription();
    supportTypeCtrl = new FormControl(undefined, [Validators.required]);

    isMobile: any;
    isSaving = false;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        public dialogRef: MatDialogRef<TicketTypeDialogComponent>,
        private messageService: MessageService,
        private appService: AppService,
        @Inject(MAT_DIALOG_DATA) public ticket: Ticket,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.appService.isMobileScreen;
        this.ticketTyp = new SupportedTypes();
        this.ticketTyp.tickettyp_id = this.ticket.tickettyp_id;
        this.ticketTyp.typ = this.ticket.tickettyp;
        this.supportTypeCtrl.setValue(this.ticketTyp);
        this.readSupportTypes();
    }

    ticketTypComparator(t1: SupportedTypes, t2: SupportedTypes): boolean {
        return t1.tickettyp_id === t2.tickettyp_id;
    }

    readSupportTypes() {
        this.supportTypeSub?.unsubscribe();
        this.supportTypeSub = this.api.getAll(this.apiBaseUrl + 'ticket_typ/read.php').subscribe({
            next: response => {
                this.supportTypes = response.records;
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Support-Typen!', error);
            },
        });
    }

    public closeDialog(): void {
        this.isSaving = true;
        this.ticketTyp = this.supportTypeCtrl.value;
        this.ticket.tickettyp_id = this.ticketTyp.tickettyp_id;
        this.ticket.tickettyp = this.ticketTyp.typ;
        this.api.post(this.apiBaseUrl + 'ticket/update.php', this.ticket).subscribe({
            next: () => {
                this.messageService.infoMessage('Supporttyp gespeichert');
                this.dialogRef.close(true);
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Speichern des Supporttyps', error);
                this.isSaving = false;
            },
        });
    }
}
